import React, { useState, useEffect } from "react";
import './Header.css';
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu on window resize if desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 700 && menuOpen) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="logo">
        <img
          src="/images/pelican_logo.png"
          alt="Pelican Infotech"
          className="logo-img"
        />
      </div>
      <button
        className={`nav-toggle${menuOpen ? " open" : ""}`}
        aria-label="Toggle navigation menu"
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
      <nav className={`nav${menuOpen ? " open" : ""}`}>
        <ul className="nav-links">
          <li><Link to='/' onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to='AboutUs' onClick={() => setMenuOpen(false)}>About Us</Link></li>
          <li><Link to='Service' onClick={() => setMenuOpen(false)}>Services</Link></li>
          <li><Link to='Contact' onClick={() => setMenuOpen(false)}>Contact</Link></li>
          </ul>
      </nav>
    </header>
  );
};

export default Header;